const INVALID_MOBILE_PATHS = [
  "/pages/wizard",
  "/pages/analytics",
  "/pages/integrations/hubspot-iframe",
  "/pages/integrations/hubspot",
  // Renders inside HubSpot's timeline modal, which is narrower than the
  // desktop threshold — the mobile takeover must not fire there.
  "/pages/integrations/hubspot-analytics",
  "/pages/integrations/salesforce",
  "/pages/integrations/chrome-extension",
];

const SCREEN_WIDTH_THRESHOLD = 1200;

export { INVALID_MOBILE_PATHS, SCREEN_WIDTH_THRESHOLD };
